import { graphql } from '@/generated/gql';

export const INTAKE_THREAD_LIST_QUERY = graphql(/* GraphQL */ `
  query ThreadListIntake(
    $offset: Int
    $limit: Int
    $filter: SvbrgQueryBuilderQuery
    $order: [SvbrgThreadOrder!]
    $categories: [SvbrgCategoryType!]
  ) {
    sevenbridges {
      threadList(offset: $offset, limit: $limit, filter: $filter, order: $order, categories: $categories)
        @connection(key: "threadList") {
        nodes {
          id
          sequenceNumber
          createdAt
          createdBy
          status
          demandId
          demandSequenceNumber
          demandResponsibleUsers
          summary
        }
        totalCount
      }
    }
  }
`);
